// User
export const SET_USER = "SET_USER";
export const SET_USER_PROFILE = "SET_USER_PROFILE";
export const SET_USERS_DEVICES = "SET_USERS_DEVICES";
export const SET_RELATIONSHIPS = "SET_RELATIONSHIPS";
export const SET_SPECIALTIES = "SET_SPECIALTIES";

// Share History
export const SET_SHARE_HISTORY = "SET_SHARE_HISTORY";
export const POST_SHARE_HISTORY = "POST_SHARE_HISTORY";

// Readings
export const SET_LATEST_READING_FOR_DEVICE = "SET_LATEST_READING_FOR_DEVICE";
export const SET_LATEST_READINGS_FOR_TODAY = "SET_LATEST_READINGS_FOR_TODAY";
export const SET_READING_FOR_BP_CUFF = "SET_READING_FOR_BP_CUFF";
export const SET_READING_FOR_SCALE = "SET_READING_FOR_SCALE ";
export const SET_READING_FOR_GLUCOMETER = "SET_READING_FOR_GLUCOMETER";
export const SET_READING_FOR_THERMOMETER = "SET_READING_FOR_THERMOMETER";
export const SET_READING_FOR_PULSE_OXIMETER = "SET_READING_FOR_PULSE_OXIMETER";

// Wordle
export const GET_ALL_GUESSED_WORDS = "GET_ALL_GUESSED_WORDS";
export const SAVE_WORD_ROW = "SAVE_WORD_ROW";
export const SET_ALL_WORDLE_WORDS = "SET_ALL_WORDLE_WORDS";
export const SET_BEST_STREAK = "SET_BEST_STREAK";
export const SET_CURRENT_STREAK = "SET_CURRENT_STREAK";
export const SET_FOUND = "SET_FOUND";
export const SET_GAME_RECORD = "SET_GAME_RECORD";
export const SET_GUESSED_WORD = "SET_GUESSED_WORD";
export const SET_GUESSES = "SET_GUESSES";
export const SET_HINT = "SET_HINT";
export const SET_LETTER_BOX_COLORS = "SET_LETTER_BOX_COLORS";
export const SET_MISS = "SET_MISS";
export const SET_WORDLE_GAME_ID = "SET_WORDLE_GAME_ID";
export const SET_WORDLE_WORD = "SET_WORDLE_WORD";
export const SET_WORDLE_WORD_ID = "SET_WORDLE_WORD_ID";
export const UPDATE_ATTEMPTED_GUESSES = "UPDATE_ATTEMPTED_GUESSES";
export const UPDATE_GAME_WON = "UPDATE_GAME_WON";
export const UPDATE_LETTERS_GUESSED = "UPDATE_LETTERS_GUESSED";
export const UPDATE_PLAYING_GAME = "UPDATE_PLAYING_GAME";
export const UPDATE_WORDLE_GAME = "UPDATE_WORDLE_GAME";
export const SET_PREVIOUS_GAME_RECORD = "SET_PREVIOUS_GAME_RECORD";
